import React from 'react';
import styled from 'styled-components';
import { colors } from '@nauto/core';

export interface Props {
  className?: string;
  children: any;
}

class ControlBar extends React.Component<Props, {}> {
  public render() {
    const { className, children } = this.props;
    return (
      <div className={className}>
        <nav>
          <section>{children}</section>
          <div className="shadow" />
        </nav>
      </div>
    );
  }
}

export default styled(ControlBar)`
  > nav {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    height: 3.125rem;
    background-color: #fff;
    padding: 0 1rem;
    z-index: 9;
    border-bottom: 1px solid ${colors.grey100};

    > section {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
    > section {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
    }
    > span {
      padding-left: 10px;
    }
  }
`;
